import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import InvoiceRightSide from "./InvoiceRightSide";

// Using a standard function component syntax is often cleaner.
const InvoiceFiveHeader = ({ data }: { data: any }) => {
  return (
    // CHANGED: Replaced Table with a div using Flexbox for reliable layout.
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    }}>

      {/* Item 1: The Logo */}
      <div>
        <Image
          // CHANGED: Removed the 'img-fluid' class to prevent unwanted scaling.
          className="for-light" 
          src={dynamicImage(data.image)} 
          alt="logo" 
          // CHANGED: Added maxWidth to ensure the image never grows too large.
          style={{ width: '150px', height: '100px', borderRadius: "50%", maxWidth: '150px' }} 
        />
        <Image
          className="for-dark"
          src={dynamicImage(data.image)} 
          alt="logo" 
          style={{ width: '150px', height: '100px', borderRadius: "50%", maxWidth: '150px' }}
        />
      </div>

      {/* Item 2: The Right Side Content */}
      <div>
        <InvoiceRightSide />
      </div>
      
    </div>
  );
};

export default InvoiceFiveHeader;